<template>
    <div class="stars-pp" :class="{ allow: allowClick }">
        <img
            class="star"
            :src="require(`@/assets/star${[1, 2, 3, 4, 5].includes(getStarsFullNumber) ? '-full' : ''}.svg`)"
            alt="star"
        />
        <img
            class="star"
            :src="require(`@/assets/star${[2, 3, 4, 5].includes(getStarsFullNumber) ? '-full' : ''}.svg`)"
            alt="star"
        />
        <img
            class="star"
            :src="require(`@/assets/star${[3, 4, 5].includes(getStarsFullNumber) ? '-full' : ''}.svg`)"
            alt="star"
        />
        <img
            class="star"
            :src="require(`@/assets/star${[4, 5].includes(getStarsFullNumber) ? '-full' : ''}.svg`)"
            alt="star"
        />
        <img
            class="star"
            :src="require(`@/assets/star${[5].includes(getStarsFullNumber) ? '-full' : ''}.svg`)"
            alt="star"
        />
    </div>
</template>

<script>
export default {
    name: 'StarsPPFix',
    props: {
        starsFullNumber: {
            type: Number,
            default: 0
        },
        allowClick: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            qtdStars: 0
        }
    },
    methods: {
        getQtdStars() {
            return this.qtdStars
        }
    },
    computed: {
        getStarsFullNumber() {
            return this.starsFullNumber
        }
    },
    mounted() {
        this.qtdStars = this.starsFullNumber
    }
}
</script>

<style scope src="./StarsPP-light-theme.css"></style>



// WEBPACK FOOTER //
// src/ui/stars-pp/StarsPPFix.vue